import { Box } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';

import { buildAppRouteUrl } from './utils';

import type { FQrCodeProps } from './types';

function FQrCode({ route, size = 160 }: FQrCodeProps) {
  return (
    <Box aria-label="QR code" role="img" sx={{ display: 'inline-flex', lineHeight: 0 }}>
      <QRCodeSVG value={buildAppRouteUrl(route)} size={size} />
    </Box>
  );
}

export default FQrCode;
